import optimizely from '@optimizely/optimizely-sdk';

export const OPTIMIZELY_USER_ID_KEY = 'OPTIMIZELY_USER_ID_KEY';

// https://michalzalecki.com/generate-unique-id-in-the-browser-without-a-library/
function randomId() {
  const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
  return uint32.toString(16);
}

function getOptimizelyUserId() {
  try {
    return localStorage.getItem(OPTIMIZELY_USER_ID_KEY);
  } catch(exception) {
    console.error('[LANDING OPTIMIZELY LOAD] Cannot get the id from the storage');
    return null;
  }
}

function createOptimizelyUserId() {
  const generatedUserId = randomId() + randomId();

  try {
    localStorage.setItem(OPTIMIZELY_USER_ID_KEY, generatedUserId);
  } catch (e) {
    console.error('[LANDING OPTIMIZELY LOAD] Cannot store the id');
  }

  return generatedUserId;
}

function readOptimizelyKey() {
  const configuration = document.getElementById('optimizely-conf');
  if (configuration === undefined || configuration === null) {
    throw new Error('Optimizely configuration not found');
  }

  if (!configuration.hasAttribute('data-optimizely-key')) {
    throw new Error('Optimizely key not found in configuration');
  }

  return configuration.getAttribute('data-optimizely-key');
}

export const optimizelyUserId = getOptimizelyUserId() || createOptimizelyUserId();

const readKey = readOptimizelyKey();
export const optimizelyClientInstance = optimizely.createInstance({
  sdkKey: readKey,
});
